import { Injectable } from '@angular/core';
import { AngularFire } from 'angularfire2';
import { AuthData } from '../providers/auth';
import { Database } from '../providers/database';
import * as firebase from 'firebase';

@Injectable()

export class ReserveData {

  listenerController: any;

  constructor(public af: AngularFire, public auth: AuthData, public db: Database) {
  }

  getReserve(client, reserveId) {
    return this.af.database.object('/Clients/' + client.url + '/Reserves/' + reserveId);
  }

  getReservesUser(client) {
    return this.af.database.list('/Clients/' + client.url + '/___ReserveUsers/' + this.auth.getUser().uid);
  }

  getDiaryChild(client, tokenEvent, diaryId) {
    return this.af.database.object('/Clients/' + client.url + '/Events/' + tokenEvent + '/Diary/' + diaryId);
  }

  createReserve(client, reserveChild, reserveId, reserveInfo, reserveData, reserveType) {
    return new Promise((resolve, reject) => {
      this.db.getDataEqual('/Clients/' + client.url + '/___ReserveUsers/' + this.auth.getUser().uid, 'reserveId', reserveId)
      .then((result: any) => {
        if (result.val()){
          console.log(result.numChildren() + reserveData.quantity, reserveInfo.max)
          if (reserveInfo.max < (result.numChildren() + reserveData.quantity)) {
            reject({error: 'El número de reservas supera la cantidad permitida'});
          } else {
            this.createRes(client, reserveId, reserveInfo, reserveData, reserveChild, reserveType)
            .then((result) => {
              resolve(result);
            })
            .catch((error) => {
              reject(error);
            });
          }
        } else {
          this.createRes(client, reserveId, reserveInfo, reserveData, reserveChild, reserveType)
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
        }
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  createRes(client, reserveId, reserveInfo, reserveData, reserveChild, reserveType) {
    return new Promise((resolve, reject) => {
      let obj = {
        id:'',
        reserveChild: reserveChild,
        reserveId: reserveInfo.id,
        isPay: reserveInfo.isPay,
        max: reserveInfo.max,
        reserveType: reserveType,
        nameField: reserveInfo.nameField,
        description: reserveInfo.description,
        price: reserveInfo.price,
        totalValue: (reserveInfo.price * reserveData.quantity) || 0,
        quantity: reserveData.quantity,
        aditionalInfo: reserveData.aditionalInfo,
        createdAt: new Date().getTime(),
        complete: reserveInfo.isPay ? false : true,
        user: {
          uid: this.auth.getUser().uid,
          email: this.auth.getUser().email || 'Anonymous',
        }
      };

      this.db.pushData('/Clients/' + client.url + '/___ReserveUsers/' + this.auth.getUser().uid, obj)
      .then((result2: any) => {
        firebase.database().ref().child('/Clients/' + client.url + '/Reserves/' + reserveId + '/numReserves').transaction((currentCount) => {
          return currentCount + reserveData.quantity;
        });

        obj.id = result2;

        this.db.updateData('/Clients/' + client.url + '/___Reserves/' + reserveId + '/' + obj.id, obj).then(() => {
          resolve(obj);
        });
      })
      .catch(error => {
        reject(error);
      });
    });
  }

}
// end file



// WEBPACK FOOTER //
// ./src/providers/reserve.ts